import { take, fork, cancel, select, put, call, delay } from 'redux-saga/effects';
import actionTypes from '../actionTypes';
import { callApi } from "./callApi";
import config from '../../config/config';
import {getCurrentClubId, getCurrentClubAdminToken, getCurrentClubToken, getCurrentClubPlayerId, getCurrentClubPlayerToken} from '../selectors';
import {showNotification} from "../actionCreators/notification";
import {requestCurrentClubMembers } from "../actionCreators/club";
import {
  removeMemberSuccess,
  removeMemberFailure,
  quitMemberClubSuccess,
  successChangeMemberStatus,
  agentDetailsRequest,
  agentDetailsSuccess,
  agentDetailsFailure,
  memberDetailsRequest,
  memberDetailsSuccess,
  memberDetailsFailure,
} from "../actionCreators/member";
import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory();

function* changeMemberStatus( {memberId: accountId, doAccept} ) {
    try {
        const skinId = yield select(getCurrentClubId);
        const token = yield select(getCurrentClubAdminToken);
        const params = {
            accountId,
            skinId,
            token,
            fromPending: 1,
            declined: doAccept ? 0 : 1
        };
        yield call(callApi, `${config.API_URL}/club/account`, 'POST', params);

        yield put(successChangeMemberStatus());
        yield put(showNotification({message: `Successfully ${doAccept ? 'accepted' : 'declined'} the member`}));
    } catch (e) {}
}

export function* watchChangeMemberStatus() {
    while (true) {
        const action = yield take(actionTypes.CHANGE_MEMBER_STATUS_REQUEST);
        yield fork(changeMemberStatus, action);
    }
}

function* removeMember({ memberId: accountId }) {
    try {
        const skinId = yield select(getCurrentClubId);
        const token = yield select(getCurrentClubToken);
        const params = {
            accountId,
            skinId,
            token,
            declined: 0
        };
        yield call(callApi, `${config.API_URL}/club/account/${accountId}/player`, 'DELETE', params);

        yield put(removeMemberSuccess());
        yield  browserHistory.goBack();

        yield put(showNotification({message: `Successfully removed the member`}));
    } catch (e) {
        yield put(removeMemberFailure(e));
    }
}

function* quitMemberClub({ history }) {
    try {
        const skinId = yield select(getCurrentClubId);
        const accountId = yield select(getCurrentClubPlayerId);
        const token = yield select(getCurrentClubPlayerToken);
        const params = {
            accountId,
            skinId,
            token,
            declined: 0
        };
        yield call(callApi, `${config.API_URL}/club/account/${accountId}/player`, 'DELETE', params);

        yield put(quitMemberClubSuccess());
        yield put(showNotification({message: `Successfully quit the club`}));
        history.push('/');
    } catch (e) {}
}

export function* watchRemoveMember() {
    while (true) {
        const action = yield take(actionTypes.REMOVE_MEMBER_REQUEST);
        yield fork(removeMember, action);
    }
}
export function* watchQuitMemberClub() {
    while (true) {
        const action = yield take(actionTypes.QUIT_MEMBER_CLUB_REQUEST);
        yield fork(quitMemberClub, action);
    }
}

function* processAgentDetailsRequest({ agentId, dateFrom, dateTo }) {
  try {
    const token = yield select(getCurrentClubAdminToken);
    const params = {
      accountId: agentId,
      token,
    };
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    const response = yield call(callApi, `${config.API_URL}/club/networkSummary`, 'GET', params);
    yield put(agentDetailsSuccess(agentId, response.data.result));
  } catch (e) {
    yield put(agentDetailsFailure(agentId, e));
  }
}

export function* watchAgentDetails() {
  let forked = null;
  while (true) {
    const action = yield take(actionTypes.AGENT_DETAILS_REQUEST);
    if (forked) yield cancel(forked);
    forked = yield fork(processAgentDetailsRequest, action);
  }
}

function* processMemberDetailsRequest({ accountId, dateFrom, dateTo }) {
  try {
    const token = yield select(getCurrentClubAdminToken);
    const params = {
      accountId,
      token,
    };
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    const response = yield call(callApi, `${config.API_URL}/club/networkSummary`, 'GET', params);
    yield put(memberDetailsSuccess(accountId, response.data.result));
  } catch (e) {
    yield put(memberDetailsFailure(accountId, e));
  }
}

export function* watchMemberDetails() {
  let forked = null;
  while (true) {
    const action = yield take(actionTypes.MEMBER_DETAILS_REQUEST);
    if (forked) yield cancel(forked);
    forked = yield fork(processMemberDetailsRequest, action);
  }
}